<template>
    <UserPageLayout> </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import appConfig from '@/app.config'
import Request from '@/lib/request'
import { currentUser } from '@/lib/user'

export default {
    components: {
        UserPageLayout
    },

    data() {
        return {
            playerLimit: ''
        }
    },

    created() {
        var request = new Request()
        this.$store.commit('toggleMainLoader', true)

        if (window.location.search.length) {
            var params = {},
                query = window.location.search.replace(/\?/, '').split('&')

            query.forEach(function (q) {
                var param = q.split('=')
                params[param[0]] = param[1]
            })

            if (params['params']) {
                var resData = atob(decodeURIComponent(params['params']))
                resData = JSON.parse(resData)

                if (resData.id_empotency_key != undefined) {
                    var payload = {
                        user: currentUser(),
                        plan_id: resData.p,
                        id_empotency_key: resData.id_empotency_key
                    }

                    request.post(appConfig.api.vippsCreateSubscriptionOrder, payload).then(res => {

                        let url = res.data.data.url
                        url = new URL(url)
                        url.searchParams.set('mt', 'vp')
                        url = url.toString()

                        window.location.href = url
                    })
                }
            }
        }
    }
}
</script>
